<template>
  <div id="app">
    <router-view :session="session"/>
  </div>
</template>

<script>
export default {
  name: 'App',
  props: ['session']
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.no-sided-margin {
  margin-right: unset;
  margin-left: unset;
}

.no-sided-padding {
  padding-right: unset !important;
  padding-left: unset !important;
}

.margin-top-md {
  margin-top: 1rem;
}

.margin-top-sm {
  margin-top: 0.5rem;
}

.margin-top-lg {
  margin-top: 1.5rem;
}

.margin-top-xl {
  margin-top: 2rem;
}

.margin-bottom-md {
  margin-bottom: 1rem;
}

.margin-bottom-sm {
  margin-bottom: 0.5rem;
}

.margin-bottom-lg {
  margin-bottom: 1.5rem;
}

.margin-bottom-xl {
  margin-bottom: 2rem;
}

.padding-md {
  padding: 1rem;
}

.padding-sm {
  padding: 0.5rem;
}

.padding-lg {
  padding: 1.5rem;
}

.padding-xl {
  padding: 2rem;
}

.card > .card-body,
.card > .card-body > .card-body,
.card > .card-body > .card-body > .table-responsive {
  padding: unset;
  margin-bottom: unset;
}

.custom-card-header {
  height: 1.5rem;
}

.card > .card-header {
  border-bottom: unset;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

h6, h5, h4, h3, h2, h1 {
  margin-bottom: unset !important;
  font-weight: bold;
}

.heading-small {
  font-size: .75rem;
  padding-top: .25rem;
  padding-bottom: .25rem;
  letter-spacing: .04em;
  text-transform: uppercase;
  font-weight: bold;
}

.cap-smalled {
  font-size: small;
  text-transform: uppercase;
  font-variant: small-caps;
}

.uppercase {
  text-transform: uppercase;
}

.nav-link {
  font-size: small;
  text-transform: uppercase;
  font-variant: small-caps;
}

.table th, .table td {
  vertical-align: middle !important;

}

.col-form-label {
  color: #6c757d !important;
  font-size: 80% !important;
  font-weight: 400;
}
</style>
